if (!customElements.get("grid-reviews")) {
  class GridReviews extends HTMLElement {
    constructor() {
      super();
      this.selectors = {
        medias: [".media-item"]
      }
      this.handlePhotoswipe();
      this.initPhotoswipe();
    }

    handlePhotoswipe(customData = []) {
      const medias = [...this.querySelectorAll(".media-item")];

      const data = medias.map((media) => {
        const { mediaType, index: id } = media.dataset;

        if (mediaType === "image") {
          const {
            mediaSrc: src,
            mediaWidth,
            mediaHeight,
            mediaAlt: alt,
          } = media.querySelector(".media-image").dataset;
          return {
            src,
            width: parseInt(mediaWidth),
            height: parseInt(mediaHeight),
            alt,
            id,
          };
        } else {
          const src = media.querySelector("[type='video/mp4']").src
          return {
            html: `<div class="w-full h-full flex items-center justify-center"><div class="pswp-video"><video class="mx-auto" controls><source src="${src}" type="video/mp4"></video></div></div>`,
            type: mediaType,
            id,
          };
        }
      });

      const options = {
        dataSource: customData.length ? customData : data,
        bgOpacity: 1,
        close: false,
        zoom: false,
        arrowNext: false,
        arrowPrev: false,
        counter: false,
        preloader: false,
        pswpModule: HimiLibs.PhotoSwipeLightbox.PhotoSwipe,
      };
      this.lightbox = new HimiLibs.PhotoSwipeLightbox(options);

      // UI elements
      const uiElements = [
        {
          name: "m-close",
          order: 11,
          isButton: true,
          html: '<svg class="svg-icon--large" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"></path></svg>',
          onClick: (event, el, pswp) => pswp.close(),
        },
        {
          name: "m-arrowNext",
          order: 12,
          isButton: true,
          html: '<svg fill="currentColor" width="14px" height="14px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M218.101 38.101L198.302 57.9c-4.686 4.686-4.686 12.284 0 16.971L353.432 230H12c-6.627 0-12 5.373-12 12v28c0 6.627 5.373 12 12 12h341.432l-155.13 155.13c-4.686 4.686-4.686 12.284 0 16.971l19.799 19.799c4.686 4.686 12.284 4.686 16.971 0l209.414-209.414c4.686-4.686 4.686-12.284 0-16.971L235.071 38.101c-4.686-4.687-12.284-4.687-16.97 0z"></path></svg>',
          onClick: (event, el, pswp) => pswp.next(),
        },
        {
          name: "m-arrowPrev",
          order: 10,
          isButton: true,
          html: '<svg width="14px" height="14px" fill="currentColor" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M229.9 473.899l19.799-19.799c4.686-4.686 4.686-12.284 0-16.971L94.569 282H436c6.627 0 12-5.373 12-12v-28c0-6.627-5.373-12-12-12H94.569l155.13-155.13c4.686-4.686 4.686-12.284 0-16.971L229.9 38.101c-4.686-4.686-12.284-4.686-16.971 0L3.515 247.515c-4.686 4.686-4.686 12.284 0 16.971L212.929 473.9c4.686 4.686 12.284 4.686 16.971-.001z"></path></svg>',
          onClick: (event, el, pswp) => pswp.prev(),
        },
      ];

      this.lightbox.on("uiRegister", () => {
        this.lightbox.pswp.ui.registerElement(uiElements[0]);
          uiElements.slice(1).forEach((element) => this.lightbox.pswp.ui.registerElement(element));
      });
    }

    initPhotoswipe() {
      this.lightbox.init();

      const handleMediaClick = (e, media) => {
        e.preventDefault();
        const index = Number(media.dataset.index) || 0;
        this.lightbox.loadAndOpen(index);
      };

      addEventDelegate({
        selector: this.selectors.medias[0],
        context: this,
        handler: handleMediaClick,
      });
    }
  }

  customElements.define('grid-reviews', GridReviews);
}